import axios from 'axios';

export type ImageUrls = {
  small: string;
  medium: string;
  large: string;
  original: string;
};

export async function uploadImage(
  filename: string,
  file: File,
): Promise<ImageUrls> {
  const { data } = await axios.post<{ uploadUrl: string; urls: ImageUrls }>(
    'http://localhost:3001/upload',
    { filename, contentType: file.type },
  );

  await axios.put(data.uploadUrl, file, {
    headers: { 'Content-Type': file.type },
  });

  return data.urls;
}

export function getFileExtension(filename: string): string {
  return filename.includes('.') ? filename.split('.').pop()! : 'jpg';
}
